module.exports = __webpack_public_path__ + "img/Ilustration.785d50cd.png";